import React, { useState } from 'react';

import { ReactComponent as CheckIcon } from './../assets/icons/circle-check-icon.svg';
import { ReactComponent as ExclamationIconYellow } from './../assets/icons/circle-exclamation-yellow-icon.svg';
import { ReactComponent as ExclamationIconRed } from './../assets/icons/circle-exclamation-red-icon.svg';
import { ReactComponent as HelpIcon } from './../assets/icons/help-icon.svg';

import { DataStatus } from '../types';
interface ToolTipProps {
  data: DataStatus;
  variant?: string;
  orientation?: string;
}
interface VariantProps {
  [key: string]: {
    [key: string]: string;
  };
}

const ToolTip: React.FC<ToolTipProps> = ({ children, data, variant, orientation }) => {
  const variantStyles: VariantProps = {
    label: {
      full: 'text-connectGray',
      partial: 'text-connectYellow',
      unavailable: 'text-connectRed',
      help: 'text-connectWhite',
      tag: 'text-navy'
    },
    tooltip: {
      full: 'bg-connectGray w-[132px]',
      partial: 'bg-connectYellow w-[132px]',
      unavailable: 'bg-connectRed w-[132px]',
      help: 'bg-connectDarkGray w-[190px]',
      tag: `bg-navy ${data.message && data.message?.length > 30 ? 'w-[190px]' : 'w-[132px]'} `,
      defaultOrientation: `bottom-10 ${data.status === 'TAG' ? 'left-10' : 'left-2'} transform -translate-x-2/4`,
      topCenter: 'top-10 left-2 transform -translate-x-2/4',
      topRight: 'top-[-30px] left-[30px]'
    },
    background: {
      defaultOrientation: 'top-0 bottom-0 left-[5px] right-[5px]',
      topCenter: 'top-0 bottom-0 left-[5px] right-[5px]',
      topRight: 'left-0 right-0 top-[5px] bottom-[5px]'
    },
    arrow: {
      full: 'bg-connectGray',
      partial: 'bg-connectYellow',
      unavailable: 'bg-connectRed',
      tag: 'bg-navy',
      help: 'bg-connectDarkGray shadow-cardShadow',
      defaultOrientation: 'left-[50%] -translate-x-2/4 -translate-y-2/4',
      topCenter: 'top-0 left-[50%] -translate-x-2/4 -translate-y-2/4',
      topRight: 'top-[34px] left-[-10px]'
    }
  };

  const [showToolTip, setShowToolTip] = useState<boolean>(false);

  const getIconFromStatus = (status: string) => {
    let icon;
    switch (status) {
      case 'FULL':
        icon = <CheckIcon className={'inline-block fill-[#D0D0D0]'} />;
        break;
      case 'PARTIAL':
        icon = <ExclamationIconYellow className={'inline-block'} />;
        break;
      case 'UNAVAILABLE':
        icon = <ExclamationIconRed className={'inline-block'} />;
        break;
      case 'HELP':
        icon = <HelpIcon className={'inline-block'} />;
        break;
    }
    return icon;
  };

  return (
    <div className="relative inline-block">
      <div
        className="inline-block cursor-pointer"
        onMouseEnter={() => setShowToolTip(true)}
        onMouseLeave={() => setShowToolTip(false)}
      >
        {data.status !== 'TAG' ? getIconFromStatus(data.status) : ''}
        {data.label && data.status === 'PARTIAL' && (
          <span className={`inline ml-1 font-nunitoBold text-[10x] ${variantStyles.label[data.status.toLowerCase()]}`}>
            {data.label}
          </span>
        )}
        {data.label && data.status === 'TAG' && (
          <span className={`inline ml-1 font-nunitoBold text-[15x] ${variantStyles.label[data.status.toLowerCase()]}`}>
            {data.label}
          </span>
        )}
      </div>
      {showToolTip && (
        <div
          className={`block absolute rounded shadow-cardShadow z-30 ${
            variantStyles.tooltip[data.status.toLowerCase()]
          } ${orientation ? variantStyles.tooltip[orientation] : variantStyles.tooltip['defaultOrientation']}`}
        >
          {variant && variant === 'info' ? (
            <React.Fragment>
              <div
                className={`absolute bg-white z-10
              ${orientation ? variantStyles.background[orientation] : variantStyles.background['defaultOrientation']}`}
              ></div>
              {children}
            </React.Fragment>
          ) : (
            <p className={'text-white font-nunitoBold text-[10px] p-[12px] leading-normal text-center relative z-30'}>
              {data.message}
            </p>
          )}
          <div
            className={`absolute  ${variantStyles.arrow[data.status.toLowerCase()]} ${
              orientation ? variantStyles.arrow[orientation] : variantStyles.arrow['defaultOrientation']
            } transform rotate-45 w-[20px] h-[20px] rounded-sm z-0 `}
          ></div>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
